import { useDispatch } from 'react-redux';
import { setImageUrl } from '../../../v2/store/users';
import AvatarUploader from '../../2compounds/AvatarUploader/AvatarUploader'
import SaveConfirmationModal from '../../2compounds/SaveConfirmationModal/SaveConfirmationModal'
import {texts} from '../../../consts/Texts'
import {Text} from '../../1elements'
import {DIV} from './styles'
import uploadIcon from '../../1elements/Icons/svg/upload.svg'
import {useEffect, useState} from 'react'
import ApiService from '../../../common/ApiCalls'
import LoaderBackdrop from '../../2compounds/LoaderBackdrop'
import { useUserSelector } from '../../../v2/store/users';

const UploadAvatarModal = ({onEditMode, setOnEditMode, userId, existingAvatar, setSnackbar, onSave}) => {
    const { userId: userIdInStorage } = useUserSelector();
    const [imageFile, setImageFile] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
  
  const dispatch = useDispatch();

    const cancelHandler = () => {
        setOnEditMode(false)
        setImageFile(null)
    }

  const saveHandler = async () => {
    try {
      setIsLoading(true);
      const data = imageFile ? imageFile[0] : {};
      const res = await ApiService().updateAvatar(userId, data);
      const newUrl = res?.data?.data;
      if (userId === userIdInStorage) {
        localStorage.setItem('image_url', newUrl);
        dispatch(setImageUrl(newUrl));
      }
      setIsLoading(false);
      setOnEditMode(false);
      setSnackbar(prevState => ({ ...prevState, isOpen: true }));
      if (onSave) {
        onSave(newUrl, userId);
      }
    } catch (e) {
      console.log(e);
      setIsLoading(false);
    }
  };

    const props = {
        open: onEditMode,
        setOpen: setOnEditMode,
        heading: texts.imageUploader.heading,
        icon: uploadIcon,
        saveHandler,
        cancelHandler
    }

    useEffect(()=>{
        if(existingAvatar){
            setImageFile([{preview: existingAvatar}])
        }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [onEditMode])

    return (
        <SaveConfirmationModal {...props} >
            <DIV>
                <Text className={'sub-heading'}>{texts.imageUploader.subHeading}</Text>
                <AvatarUploader imageFile={imageFile} setImageFile={setImageFile} />
            </DIV>
            <LoaderBackdrop open={isLoading} />
        </SaveConfirmationModal>
    )
}

export default UploadAvatarModal
